import React from 'react';
type Tome = {
  number: string;
  title: string;
  range: string;
  promise: string;
  badge: string;
  flag?: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'First Practices: Stick Skills From Zero',
  range: '16 practices · cradle, catch, throw, scoop',
  promise: 'Get every beginner cradling, catching, throwing and scooping — with every kid moving.',
  badge: 'bg-turf',
  flag: 'Start here',
  contents: ['Day One: a stick in every hand in the first 5 minutes', 'The Stick Skills Ladder and the 3-Per-Ball Rule', 'Throw overhand in 4 cues: ear, step, snap, target', 'The Scoop-Through Method for ground balls', 'Cradle Tag — the warm-up kids ask for again']
}, {
  number: '02',
  title: 'Move the Ball: Passing, Cutting & Shooting',
  range: '16 practices · spacing, cuts, dodges, shots',
  promise: 'Turn stick skills into ball movement, smart cuts and real shots on goal.',
  badge: 'bg-sky',
  contents: ['The Triangle Rule that ends bunch ball', 'Give-and-go: the two-player play every team can run', 'First dodges with the stick protected', 'Shooting stations: 4 cone goals, zero waiting']
}, {
  number: '03',
  title: 'Defense Without Slashing',
  range: '16 practices · footwork, team D, transition',
  promise: 'Defend with feet and position, play as a unit, and get the ball back up the field.',
  badge: 'bg-gold',
  contents: ['The Break Down & Mirror Method', 'The Ball-You-Goal Rule for team defense', 'The 3 calls every defender makes', 'Win it, turn, find the outlet: the first pass after a stop']
}, {
  number: '04',
  title: 'The Game Bank: Small-Sided Games',
  range: '16 practices · 2v1 to 4v3, scrimmages',
  promise: 'Practices built on games, so kids learn decisions and teamwork while they play.',
  badge: 'bg-turf',
  contents: ['The Numbers Ladder from 2v1 to 4v3', 'The 4 Game Dials: space, players, touches, scoring', 'Freeze, Fix, Go: teach in 20 seconds and restart', 'Mini-field 3v3 festival: more touches, more goals']
}, {
  number: '05',
  title: 'Game Ready: Team Offense, Clears, Rides & Game Week',
  range: '16 practices · offense, clears, game day',
  promise: 'Practices and game-day tools that help your team play together on Saturday.',
  badge: 'bg-sky',
  contents: ['The Spread & Cut Offense', 'The Clear-Ride Map and restarts made simple', 'The Game Week Template and the day-before practice', 'Fair playing-time rotation chart']
}, {
  number: '06',
  title: 'Specialists & Special Settings: Goalies, Face-offs, Draws & Box',
  range: '16 practices · the positions you never played',
  promise: 'Goalies, face-offs and draws for coaches who never played them — plus box, gym and mixed ages.',
  badge: 'bg-gold',
  contents: ['The Goalie Ready Routine any coach can run', 'Face-off vs. draw: what’s different (with U8–U10 restart versions)', 'The Box Adapter: turn any field drill into a box drill', 'Gym practice and mixed-age practice plans']
}];
const everyVolume = ['16 practices as 2-page spreads: the plan + drills, cues & fixes', '3 worksheets and a pocket field card', 'Late to the field? 5-minute setups', '20+ kids, 1 coach: big-group versions'];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-chalk text-navy" data-id="element-321" data-mp="iukdil4z5bj2">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-322" data-mp="mwp6dhnlm44n">
        <div className="text-center" data-id="element-323" data-mp="mve1feif2qby">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-turf" data-id="element-324" data-mp="rn5imyfonjpf">
            Your whole season
          </p>
          <h2 id="tomes-heading" className="mt-3 font-display font-bold uppercase text-navy text-3xl sm:text-5xl" data-id="element-325" data-mp="3r9udnnpb06o7">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-navy/70" data-id="element-326" data-mp="3c8nhq700rtyz">
            The season in the order you coach it: stick skills first, then moving
            the ball, defense, games, game week and specialists. Each volume
            stands on its own — open the one you need tonight.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-327" data-mp="3h5npcmcip4s7">
          {tomes.map(tome => <article key={tome.number} className={`flex flex-col rounded-2xl border bg-white p-6 shadow-soft ${tome.flag ? 'border-turf ring-1 ring-turf' : 'border-chalk-dark'}`} data-id="element-328" data-mp="3v0gaq1f39f6p">
              <div className="flex items-center gap-2.5" data-id="element-329" data-mp="3t3t5laamzq9">
                <span className={`flex h-8 w-8 items-center justify-center rounded-lg font-display text-lg font-bold text-white ${tome.badge}`} data-id="element-330" data-mp="2aiie0mee4qtk">
                  {tome.number}
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-widest text-navy/50" data-id="element-331" data-mp="l14pt9cx0ujw">
                  Volume {tome.number}
                </span>
                {tome.flag && <span className="ml-auto rounded bg-turf px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-white" data-id="element-332" data-mp="bcd0za35iqd7">
                    {tome.flag}
                  </span>}
              </div>
              <h3 className="mt-3 font-display text-xl font-bold uppercase leading-tight text-navy" data-id="element-333" data-mp="29bwfdtxp7bn">
                {tome.title}
              </h3>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-gold-deep" data-id="element-334" data-mp="3oid4jkccjeae">
                {tome.range}
              </p>
              <p className="mt-2 text-sm text-navy/70" data-id="element-335" data-mp="3thq2p18o47sa">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-chalk-dark pt-4" data-id="element-336" data-mp="1mqgw4jlh6kju">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-navy" data-id="element-337" data-mp="1rpbclevyzx0s">
                    <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-338" data-mp="1q9pcnn64y5ib" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-6 rounded-2xl bg-navy px-5 py-5 text-white sm:px-7" data-id="element-339" data-mp="1gaqgh42k42c7">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-gold" data-id="element-340" data-mp="1bcowmgxb3yzo">In every volume</p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-341" data-mp="28yma1zwtxe4r">
            {everyVolume.map(item => <li key={item} className="flex gap-2 text-[13px] text-white/85" data-id="element-342" data-mp="240ug70cmjhxx">
                <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-turf" data-id="element-343" data-mp="1z81budl2ibmd" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}